import { render } from "./KeyCountryIndicator.vue?vue&type=template&id=2b08986c&scoped=true&ts=true"
import script from "./KeyCountryIndicator.vue?vue&type=script&lang=ts"
export * from "./KeyCountryIndicator.vue?vue&type=script&lang=ts"

import "./KeyCountryIndicator.vue?vue&type=style&index=0&id=2b08986c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b08986c"]])

export default __exports__